export default "__VITE_ASSET__BI0hZPpf__"